import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import ImageList from "@mui/material/ImageList";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { getArchitecture } from "services/ConfigServices";
import { NotificationManager } from 'react-notifications';
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      backgroundColor: '#fff',
      //width: "30ch",
    },
  },
  formControl: {
    margin: '8px',
    minWidth: 120,
  },
  gridList: {
    height: 400,
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

const InfoLabel = styled.div`
  font-size: 14px;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
  margin-bottom: 10px;
`;

function MoveGroupDialog(props) {
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;
  const [groups, setGroups] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [requestinprogress, setRequestinprogress] = useState(false);
  
  useEffect(() => {
    if ((!groups || groups.size === 0) || requestinprogress)
      setDisabled(true);
    else
      setDisabled(false);
  });

  const handleSubmit = async (event) => {
    setRequestinprogress(true);
    axios
      .put(       
        getArchitecture(chartIdGroup),
        { parentid: groups },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {  
        console.log(res);
        if (res.status == 200) {
          NotificationManager.success("Groupe modifié");
          props.closeModal();
          props.handleSubmitSuccess();
        }
        else if (res.status == 204) {
          setRequestinprogress(false);
          NotificationManager.error("Opération impossible");
        }
        else {
          setRequestinprogress(false);
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch((res) => {
        console.log(res);
        setRequestinprogress(false);
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const classes = useStyles();

  return (
    <div>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <InfoLabel>
              Votre déplacement d'entité sera pris en compte immédiatement. Une reconsolidation est en revanche nécessaire avant la mise à jour et l'affichage des données. La reconsolidation sera effectuée sur les prochaines 24H.
            </InfoLabel>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div className={classes.treeVisible}>
              <TreeLabel>Choix du groupe parent</TreeLabel>
              <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                <EmbeddedEntitesTree
                  selectedIds={setGroups}
                  userSelectedIds={groups}
                />
              </ImageList>
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <Button
              noWrap
              disabled={disabled}
              style={{
                color: disabled ? "rgba(0, 0, 0, 0.26)" : "#FFFFFF",
                backgroundColor: disabled ? "#9798A0" : "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "0px",
                marginBottom: "0px",
                marginTop: "15px",
                fontFamily: '"Source Sans Pro",sans-serif',
                width: "96%",
                marginLeft: "2%",
              }}
              onClick={() => {
                handleSubmit();
              }}
            >
              Enregistrer
            </Button>
          </GridItem>
        </GridContainer>
      </form>
    </div>
  );
}

export default MoveGroupDialog;
